import Typography from "@mui/material/Typography";

import { useTranslationApp } from "../../../../lib/i18next";
import {
  MODAL_META_AD_LIBRARY_DURATION_DAYS,
  MODAL_META_AD_LIBRARY_DURATION_HOURS,
} from "../../../../i18n/keysTranslations";
import { getMetaAdActiveDurationDisplay } from "../../../../services/competitorAdsGallery";

const CompetitorDurationBadge = ({ activeDurationHours }) => {
  const { t } = useTranslationApp();

  const display = getMetaAdActiveDurationDisplay(activeDurationHours);
  if (!display) return null;

  const labelKey =
    display.unit === "hours"
      ? MODAL_META_AD_LIBRARY_DURATION_HOURS
      : MODAL_META_AD_LIBRARY_DURATION_DAYS;

  return (
    <Typography
      variant="caption"
      component="span"
      sx={{
        color: "#000",
        fontSize: "0.7rem",
        whiteSpace: "nowrap",
        flexShrink: 0,
      }}
    >
      {t(labelKey, { count: display.value })}
    </Typography>
  );
};

export default CompetitorDurationBadge;
